import React from 'react';
import Menu from './menu';
import Sidebar from './sidebar';
import socailimg from '../assets/social.jpg'; // Import the image file
import Footer from './footer';

const Works = () => {
    return (
        <div>
             <div class="container mt-5">
        <div class="row">
        <div class="col-sm-12 col-lg-3 col-xl-3 col-md-3">
               <Sidebar/>
            </div>
            <div class="col-sm-12 col-lg-9 col-xl-9 col-md-9">
            <Menu/>
            <div class="bostami-page-content-wrap">

<section class="">
<div class="section-wrapper pl-60 pr-60 pt-60">
<div class="bostami-page-title-wrap mb-15">
<div class="three">
                                <h1 class="">Social Welfare</h1>
                                </div>
   

<p class="mt-5">In addition to my professional work, I am deeply committed to giving back to the community through various initiatives aimed at fostering growth and opportunity. My dedication to supporting others is evident in several key areas:</p>
<div class="mt-5 mb-5">
    <div class="card shadow-sm p-5 bg-catkrill" style={{borderRadius:'35px 0px 35px 0px',borderTop:'4px solid #5bb7f1',borderRight:'none',borderLeft:'4px solid #5bb7f1',borderBottom:'none'}}>
        <p><b>Career Guidance and Mentorship:</b> I provide career guidance to new graduates and early-career professionals, offering advice on career development, job search strategies, and industry insights. Through one-on-one mentorship, I help individuals navigate their career paths, build essential skills, and achieve their professional aspirations.</p>
    </div>
    </div>
    <div class="mt-5 mb-5">
    <div class="card shadow-lg p-5 bg-prink" style={{borderRadius:'35px 0px 35px 0px',borderBottom:'4px solid #f9c2c2',borderLeft:'none',borderRight:'4px solid #f9c2c2',borderTop:'none'}}>
   <p><b>Job Creation and Opportunities:</b> I actively work to create job opportunities by collaborating with organizations and industry partners. My efforts are focused on bridging the gap between talent and employment, ensuring that individuals have access to meaningful job prospects and career advancement.</p>
       
    </div>
    </div>

    <div class="mt-5 mb-5">
    <div class="card shadow-sm p-5 bg-catkrill" style={{borderRadius:'35px 0px 35px 0px',borderTop:'4px solid #5bb7f1',borderRight:'none',borderLeft:'4px solid #5bb7f1',borderBottom:'none'}}>
        <p><b>Promoting Technology Awareness: </b> I am passionate about promoting technology awareness and education. By organizing tech meetups, I aim to educate the community about emerging technologies, industry trends, and the potential of tech careers. My goal is to inspire and empower individuals to explore and excel in the technology field.</p>
    </div>
    </div>
    <div class="mt-5 mb-5">
    <div class="card shadow-lg p-5 bg-prink" style={{borderRadius:'35px 0px 35px 0px',borderBottom:'4px solid #f9c2c2',borderLeft:'none',borderRight:'4px solid #f9c2c2',borderTop:'none'}}>
   <p><b>Educational Sponsorship: </b> I sponsor education for economically disadvantaged individuals, providing financial support and resources to help them achieve their educational and career goals. By investing in their education, I contribute to their personal and professional growth, enabling them to pursue opportunities that might otherwise be out of reach.</p>
       
    </div>
    </div>
    <div class="mt-5 mb-5">
    <div class="card shadow-sm p-5 bg-catkrill" style={{borderRadius:'35px 0px 35px 0px',borderTop:'4px solid #5bb7f1',borderRight:'none',borderLeft:'4px solid #5bb7f1',borderBottom:'none'}}>
        <p><b>Supporting Non-Profit Initiatives: </b> I collaborate with non-profit organizations that focus on education and technology empowerment. Through volunteering, donations, and advocacy, I support programs that aim to make a positive impact on underserved communities and promote equitable access to education and technology.</p>
    </div>
    </div>
    <div class="mt-5 mb-5">
    <div class="card shadow-lg p-5 bg-prink" style={{borderRadius:'35px 0px 35px 0px',borderBottom:'4px solid #f9c2c2',borderLeft:'none',borderRight:'4px solid #f9c2c2',borderTop:'none'}}>
   <p><b>Championing Lifelong Learning: </b> I believe in the transformative power of technology and education to improve lives. I advocate for lifelong learning and personal development, encouraging individuals to continually seek knowledge, enhance their skills, and embrace new opportunities for growth.</p>
       
    </div>
    </div>
    <p class="mt-3">
    By actively engaging in these initiatives, I am committed to making a meaningful difference in the lives of others. My passion for technology and education drives me to support and uplift individuals, helping them unlock their potential and create a brighter future.
    </p>
  </div>
  </div>
</section>

                        <Footer/>
</div>
            </div>

        </div>
        </div>
        </div>
    );
}

export default Works;